// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Stdlib__Bool from "melange/bool.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__Empty from "./empty.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(id, submission, time, param) {
  const params = {};
  return Fx.Monad_syntax.let$star((params["id"] = {
    TAG: /* Value */ 1,
    _0: id
  }, Stdlib__Option.iter((function (submission) {
    params["submission"] = {
      TAG: /* Value */ 1,
      _0: Stdlib__Bool.to_string(submission)
    };
  }), submission), Stdlib__Option.iter((function (time) {
    params["time"] = {
      TAG: /* Value */ 1,
      _0: time.toString(undefined)
    };
  }), time), Subsonic__Utils.makeRequest({
    _method: "rest/scrobble",
    params: params
  }, Subsonic__Empty.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }));
}

export {
  make,
}
/* No side effect */
